import FormInput from '../inputs/input.js';

export default class InputFactory {
    static build(parent, el) {
        return new FormInput(parent, el);
    }
}
